export default {
  api: process.env.VUE_APP_API,
  google_client_id: '534040678247-bqvo91qqgr3us289rj01v0u5gvb8pqtj.apps.googleusercontent.com'
}
